import {Trans} from '@lingui/macro'
import styled from 'styled-components'

import {Box, Button, Tag, tokens} from '@pleo-io/telescope'

import {BillingInterval, Interval} from '@product-web/api/types/billing'

const CommitmentButton = styled(Button)`
    /* stylelint-disable-next-line declaration-property-value-allowed-list */
    border-width: ${tokens.sizeBorderDefault};
    /* stylelint-disable-next-line declaration-property-value-allowed-list */
    border-style: solid;
    border-radius: 0;
    border-color: ${({variant}) => (variant === 'primary' ? tokens.shade900 : tokens.shade300)};
    margin-bottom: ${tokens.spacing32};
    padding: ${tokens.spacing8} ${tokens.spacing20};
    position: relative;

    &:first-child {
        border-top-left-radius: ${tokens.arc4};
        border-bottom-left-radius: ${tokens.arc4};
        border-right-width: 0;
    }

    &:last-child {
        border-top-right-radius: ${tokens.arc4};
        border-bottom-right-radius: ${tokens.arc4};
        border-left-width: 0;
    }
`

const ButtonTag = styled(Tag)`
    position: absolute;
    top: -${tokens.spacing12};
    right: -${tokens.spacing32};
`

const IntervalSelector = ({
    selectedCommitment,
    onCommitmentChange,
    onBillingChange,
}: {
    selectedCommitment: Interval
    onCommitmentChange: (interval: Interval.MONTH | Interval.YEAR) => void
    onBillingChange: (billingInterval: BillingInterval) => void
}) => {
    return (
        <Box>
            <CommitmentButton
                variant={selectedCommitment === Interval.MONTH ? 'primary' : 'secondary'}
                onClick={() => {
                    onCommitmentChange(Interval.MONTH)
                    onBillingChange(BillingInterval.MONTHLY)
                }}
            >
                <Trans>1 month</Trans>
            </CommitmentButton>
            <CommitmentButton
                variant={selectedCommitment === Interval.YEAR ? 'primary' : 'secondary'}
                onClick={() => {
                    onCommitmentChange(Interval.YEAR)
                    onBillingChange(BillingInterval.YEARLY)
                }}
            >
                <Trans>12 months</Trans>
                <ButtonTag variant="pink">
                    <Trans>Best price</Trans>
                </ButtonTag>
            </CommitmentButton>
        </Box>
    )
}

export default IntervalSelector
